import { useLoading } from "@greeter/loading";
import { Spinner } from "./Spinner";

export function LoadingListener() {
  const loading = useLoading();
  return <Spinner reason={loading.reason} />;
}
